import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=271ae9f8"
import script from "./dropdownMenu.vue?vue&type=script&lang=js"
export * from "./dropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./dropdownMenu.vue?vue&type=style&index=0&id=271ae9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports